<template>
  <div class="login">
    <div class="welcome" style="position: relative;height:40px;text-align: center;">
      <span style="color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    font-size:33px">食堂系统登录</span>
    </div>
    <div class="login-form">
      <el-form ref="user" :model="user">
        <el-form-item class="login-inp">
          <el-input
            v-model="user.username"
            placeholder="请输入用户名(默认为姓名)"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-inp">
          <el-input
            type="password"
            v-model="user.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-inp">
          <el-button style="width: 100%" ri type="primary" @click="doLogin"
            >登录</el-button
          >
        </el-form-item>
        <!-- <el-form-item class="login-inp">
          <el-button plain style="width: 100%" type="primary" @click="register"
            >注册/修改</el-button
          >
        </el-form-item> -->
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  //单页面中不支持前面的data:{}方式
  data() {
    //相当于以前的function data(){},这是es5之前的写法，新版本可以省略掉function
    return {
      user: {
        username: "",
        password: "",
        newPassword: "",
        newPassword2: "",
        //为了登录方便，可以直接在这里写好用户名和密码的值
      },
    };
  },
  methods: {
    doLogin() {
      //一点击登录按钮，这个方法就会执行
      const loading = this.$loading();
      var that = this;
      this.axios
        .post("/User/UserLogin", {
          account: this.user.username,
          password: that.GLOBAL.aesEncrypt(this.user.password),
        })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              window.sessionStorage.setItem(
                "userToken",
                response.data.data.userToken
              );
              that.$router.push("/");
            } else if (response.data.state == -90) {
              const h = that.$createElement;
              that
                .$msgbox({
                  customClass: "winClass",
                  title: "当前账号密码未设定",
                  message: h("div", null, [
                    h("div",  { attrs: { class: "item" } },[
                    h("span", { attrs: { class: "label" } }, "密码"),
                    h("input", {
                      attrs: {
                        id: "password",
                        class: "confirm",
                        type: "password",
                      },
                      value: that.newPassword,
                      on: { input: that.onOldPwdInputChange },
                    })])
                    ,h("div",  { attrs: { class: "item" } },[
                    h("span", { attrs: { class: "label" } }, "确认密码"),
                    h("input", {
                      attrs: {
                        id: "password2",
                        class: "confirm",
                        type: "password",
                      },
                      value: that.newPassword2,
                      on: { input: that.onOldPwd2InputChange },
                    })]),
                  ]),
                  showCancelButton: true,
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  // beforeClose: (action, instance, done) => {
                  //   if (action === "confirm") {

                  //   } else {
                  //     done();
                  //   }
                  // },
                })
                .then((action) => {
                  if (that.newPassword.length < 5) {
                    that.$message.error("密码不能小于5位");
                    return;
                  } else if (that.newPassword.length > 18) {
                    that.$message.error("密码不能大于18位");
                    return;
                  }
                  if (that.newPassword != that.newPassword2) {
                    that.$message.error("两次输入密码不一致");
                    return;
                  }

                  that.axios
                    .post("/User/EditPwd", {
                      account: that.user.username,
                      password: that.GLOBAL.aesEncrypt(that.newPassword),
                    })
                    .then(function (response) {
                      if (response.status == 200) {
                        if (response.data.state == 0) {
                          that.$message.success("密码修改成功");
                        } else {
                          that.$message.error(response.data.message);
                        }
                      } else {
                        that.$message.error("请检查网络设置");
                      }
                    });
                });
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }

          //     that
          //       .$prompt( {
          //         title:"当前账号密码未设定",
          //         confirmButtonText: "确定",
          //         cancelButtonText: "取消",
          //         inputType:"password",
          //       })
          //       .then(({ value,value2 }) => {
          //         if (value.length < 5) {
          //           that.$message.error("密码不能小于5位");
          //           return;
          //         } else if (value.length > 18) {
          //           that.$message.error("密码不能大于18位");
          //           return;
          //         }
          //         that.axios
          //           .post("/User/EditPwd", {
          //             account: that.user.username,
          //             password: that.GLOBAL.aesEncrypt(value),
          //           })
          //           .then(function (response) {
          //             if (response.status == 200) {
          //               if (response.data.state == 0) {
          //                 that.$message.success("密码修改成功");
          //               } else {
          //                 that.$message.error(response.data.message);
          //               }
          //             } else {
          //               that.$message.error("请检查网络设置");
          //             }
          //           });
          //       })
          //       .catch(() => {
          //         that.$message({
          //           type: "info",
          //           message: "取消输入",
          //         });
          //       });
          //   } else {
          //     that.$message.error(response.data.message);
          //   }
          // } else {
          //   that.$message.error("请检查网络设置");
          // }
          loading.close();
        });
    },
    register() {
      this.$router.push("/Register");
    },
    onOldPwdInputChange() {
      this.newPassword = document.getElementById("password").value;
    },
    onOldPwd2InputChange() {
      this.newPassword2 = document.getElementById("password2").value;
    },
  },
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100%;
  background: url(~@/assets/bg.png) no-repeat;
  background-size: cover;
  position: fixed;
  z-index: -10;
}
.welcome {
  width: 100%;
  margin: 25% 0;
}
.welcome img {
  width: 100%;
}
.login-inp {
  margin: 0 30px 15px 30px;

  border-radius: 25px;
}
.confirm {
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 5px 4px;
  width: 70%;
  font-size: 14px;
  font-family: "Microsoft soft";
  margin-top: 5px;
  margin-bottom: 5px;
  float: left;
}
.confirm:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.label {
  padding: 5px 4px;
  width: 20%;
  font-size: 14px;
  font-family: "Microsoft soft";
  margin-top: 5px;
  margin-bottom: 5px;
  float: left;

}
.item{
  width: 100%;
  float: left;
}
</style>
<style>
.winClass {
  width: 90%;
}
</style>


// WEBPACK FOOTER //
// src/components/Login/Index.vue